<div class="outside-container mt-4">
    <div class="box-container">
        <div class="container">
            <div class="title"> 
                <div class="col-md-12 d-flex justify-content-start">
                <div class="col-md-7 d-flex justify-content-end"><h2>Booking Calendar</h2></div>
                <div class="col-md-5 d-flex justify-content-end"> 
                    <div >
                    <!-- <mat-label>Select Month and Year</mat-label> -->
                    
                </div>
            </div>
                </div> 
            </div>
            <div class="calendar-container">
               
                <div class="month-header">
                    <span>{{ selectedMonth | date: 'MMMM yyyy' }}
                      
    
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker startView="multi-year" (monthSelected)="onMonthSelected($event, picker)" panelClass="month-picker">
                    </mat-datepicker>
                    <input
                    style="border: none;outline: none;background-color: transparent;width: 150px;font-size: 20px;color: transparent;margin-top: 6px;"
                      matInput
                      [matDatepicker]="picker"
                      readonly
                      [value]="selectedDate"
                      (dateChange)="onDateChange($event)"
                    />
                    </span>
                </div>

                <!-- Days of the week header -->
                <div class="weekdays-header">
                    <span>Sun</span>
                    <span>Mon</span>
                    <span>Tue</span>
                    <span>Wed</span>
                    <span>Thu</span>
                    <span>Fri</span>
                    <span>Sat</span>
                </div>
                <mat-progress-bar *ngIf="disabled" mode="indeterminate"></mat-progress-bar>

                <!-- Calendar grid for days -->
                <div class="calendar-grid">
                    <div class="day-cell empty" *ngFor="let emptyCell of leadingEmptyCells"></div>

                    <!-- Render Days -->
                    <div class="day-cell" *ngFor="let day of daysInMonth">
                        <div class="date-number">{{ day.date.getDate() }}</div>

                        <!-- Display events for this date -->
                        <mat-progress-bar *ngIf="disabled" mode="indeterminate"></mat-progress-bar>

                        <ul *ngIf="day.events.length > 0" >
                            <li *ngFor="let event of day.events" class="shadow">
                                <strong (click)="onModifyClick(event.title)">{{ event.title }}</strong><br />
                                <span><pre>{{ event.description }}</pre></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
